var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.wrapper},_vm._l((_vm.links),function(ref){
var _obj;

var link = ref.link;
var label = ref.label;
var iconName = ref.iconName;return _c('li',{key:label,class:_vm.$style.item},[_c('Link',{attrs:{"link":link,"child-class":_vm.$style.link}},[_c('ShapedImage',{attrs:{"child-class":[
          _vm.$style.shapedImage,
          ( _obj = {}, _obj[_vm.$style.isActive] = _vm.isLinkActive(link), _obj ) ]}},[_c('Icon',{attrs:{"name":iconName}})],1),_c('Typography',{class:_vm.$style.label,attrs:{"variant":_vm.isLinkActive(link)
            ? _vm.TYPOGRAPHY_TYPES.bodyBold
            : _vm.TYPOGRAPHY_TYPES.bodyRegular}},[_vm._v("\n        "+_vm._s(label)+"\n      ")])],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }